import styled from "styled-components";
import SectionContainer, { SectionContainerProps } from "./SectionContainer";

const SectionContainerStyled = styled(SectionContainer)`
	width: 388px;
	margin-left: 16px;
	justify-content: flex-start;
`;

const RightSectionContainer = (props: RightSectionContainerProps) => {
	return (
		<SectionContainerStyled {...props}>
			{props.children}
		</SectionContainerStyled>
	);
};
export default RightSectionContainer;
export interface RightSectionContainerProps extends SectionContainerProps {}
